<template>
  <div id="deliveryRecord">
    <div class="hr_container">
      <div class="inter-tit">
        <div class="tit-slelect">
          <div class="tit-newYear">
            <span class="cp-2">年份:</span>
            <span @click="openPicker" class="tit-newYear-sele"
              >{{ currentDate }}
              <i v-if="timePicker !== true"><van-icon name="arrow-down" /></i>
              <i v-else><van-icon name="arrow-up" /></i>
            </span>
            <van-popup
              v-model="timePicker"
              round
              get-container="body"
              position="bottom"
            >
              <van-picker
                show-toolbar
                title="选择年份"
                :default-index="defaultIndex"
                :columns="columns"
                @cancel="timePicker = false"
                @confirm="confirmDate"
              />
            </van-popup>
          </div>
          <div class="tit-newYear">
            <span class="cp-2">类型:</span>
            <span @click="openPickerMonth" class="tit-newYear-sele"
              >{{ currentDateMonth }}
              <i v-if="timePickerMonth !== true"
                ><van-icon name="arrow-down"
              /></i>
              <i v-else><van-icon name="arrow-up" /></i>
            </span>
            <van-popup
              v-model="timePickerMonth"
              round
              get-container="body"
              position="bottom"
            >
              <van-picker
                show-toolbar
                title="选择月度"
                :columns="columnsMonth"
                @cancel="timePickerMonth = false"
                @confirm="confirmDateMonth"
              />
            </van-popup>
          </div>
        </div>
        <div class="tit-text">
          <div v-for="item in list" :key="item.label">
            <span class="cp-2 cp-3">{{ item.label }}</span>
            <span>{{ item.value }}</span>
          </div>
        </div>
      </div>
      <div class="inter-con">
        <div class="inter-con-tit">
          <p class="inter-border">投递进度</p>
        </div>
        <div id="compareCharts" style="height: 350px; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from '@/apis/user'
import { getToken } from "@/utils/cookie";
export default {
  name: "HR",
  data() {
    return {
      currentDate: Number(moment(new Date()).year()), // 当前展示时间
      timePicker: false,
      timePickerMonth: false,
      columns: [], //
      columnsMonth: [
        {
          text: "月度",
          value: "1",
        },
        {
          text: "季度",
          value: "2",
        },
        {
          text: "年度",
          value: "3",
        },
      ],
      list: [
        {
          label: "岗位数量：",
          value: "",
        },
        {
          label: "投递/竞聘：",
          value: "",
        },
        {
          label: "初试人数：",
          value: "",
        },
        {
          label: "复试人数：",
          value: "",
        },
        {
          label: "录用人数：",
          value: "",
        },
        {
          label: "通 过 率：",
          value: "",
        },
      ],
      defaultIndex: 0,
      currentDateMonth: "月度",
    };
  },
  created() {},
  mounted() {
    this.initYear();
    this.getList();
    this.getinit()
  },
  methods: {
    // 初始化年份
    initYear() {
      const lastYear = moment(new Date()).year();
      this.columns = [...new Array(10).keys()]
        .map((k) => {
          return `${lastYear - k}年`;
        })
        .reverse();
    },
    // 选择年份
    openPicker() {
      const currentIndex = this.columns.findIndex((item) => {
        return item === (this.currentDate + "年" || `${moment().year()}年`);
      });
      this.defaultIndex = currentIndex > -1 ? currentIndex : 0;
      this.timePicker = true;
    },
    openPickerMonth() {
      this.timePickerMonth = true;
    },
    // 回调参数: 多列：所有列选中值，所有列选中值对应的索引
    confirmDate(value) {
      const data = value.replace("年", "");
      this.currentDate = data;
      this.timePicker = false;
      this.initYear();
      this.getinit()
    },
    // 选择月份
    confirmDateMonth(value) {
      this.timePickerMonth = false;
      this.currentDateMonth = value.text;
      this.getinit()
      this.getList()
    },
    // 获取数据
    getinit(){
      api.bulletinBoard({year:this.currentDate,type:this.currentDateMonth,empNo:getToken()}).then(data=>{
          this.list[0].value = data.data.PositionNumber
          this.list[1].value = data.data.deliverNumber
          this.list[2].value = data.data.oneInterviewResult
          this.list[3].value = data.data.twoInterviewResult
          this.list[4].value = data.data.successInterviewResult
          this.list[5].value = parseInt(data.data.acceptanceRate * 100) + '%'
      })
    },
    // 获取数据
    getList(){
      api.bulletinMap({year:this.currentDate,type:this.currentDateMonth,empNo:getToken()}).then(data=>{
        this.compareCharts(data.data.data)
      })
    },
    compareCharts(data) {
      // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
      let myChart = this.$echarts.init(
        document.getElementById("compareCharts")
      );
      let name = Object.keys(data)
      let value = Object.values(data)

      // let name = ["一号", "二号", "三号", "四号", "五号", "六号"];
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["投递数量"],
        },
        xAxis: {
          data: name,
        },
        yAxis: {},
        series: [
          {
            name:'投递数量',
            type: "bar",
            color: "rgba(78, 162, 124, 1)",
            data: value,
            label:{
              show:true,
              position:'top'
            }
          }
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #deliveryRecord {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #deliveryRecord {
    width: 276px * $zoom;
  }
}
#deliveryRecord {
  font-size: 15pt;
  position: relative;
  .hr_container {
    width: 100%;
    min-height: 100vh;
    background: #f7f9fa;
    display: flex;
    flex-direction: column;
    .inter-tit {
      height: 160pt;
      background: #fff;
      margin-bottom: 15px;
      padding: 25px;
      .tit-slelect {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .tit-newYear {
          display: flex;
          align-items: center;
        }
        .tit-newYear-sele {
          border: 1px solid #ccc;
          border-radius: 5px;
          width: 200px;
          display: inline-block;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 15px;
        }
      }
      .tit-text {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        div {
          width: 47%;
          margin-top: 35px;
        }
      }
    }
    .inter-con {
      flex: 1;
      background: #fff;
      padding: 25px;
      padding-left: 20px;
      .inter-con-tit {
        position: relative;
        padding-left: 35px;
        .inter-border {
          &::after {
            content: "";
            position: absolute;
            bottom: 2px;
            left: 2%;
            transform: translateX(-50%);
            width: 3px * $zoom;
            height: 15px * $zoom;
            background: #018755;
            border-radius: 10px * $zoom;
          }
        }
      }
    }
  }
}
.cp-2 {
  color: rgba(102, 102, 102, 1);
  margin-right: 10px;
  
}
.cp-3{
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
  width: 200px;
}
</style>
